export const statuses = {
    NOT_STARTED: 'NOT_STARTED',
    ACTIVE: 'ACTIVE',
    PENDING_REVIEW: 'PENDING_REVIEW',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED_BY_ADMIN'
};

export const registrationStatuses = {
    NOT_STARTED: 'NOT_STARTED',
    IN_PROGRESS: 'IN_PROGRESS',
    FINISHED: 'FINISHED',
    INTERNAL: 'INTERNAL'
};

export const countDownModeTypes = {
    START: 'start',
    END: 'end',
    MIXED: 'mixed'
};

export const COUNT_DOWN_TYPES = {
    countdown: 'countdown',
    static: 'static'
};

export const RACE_RULE_STATUSES = {
    active: 'ACTIVE',
    approved: 'APPROVED',
    completed: 'COMPLETED'
};

export const COUNT_DOWN_FORMAT = {
    mmSS: 'mm_ss',
    hhMM: 'hh_mm',
    ddHHmm: 'dd_hh_mm'
};

export const MAX_DATE = 8640000000000000;
